import { Form as AntdForm } from "antd";
import { FormProps as AntdFormProps } from "antd/lib/form";
import React, { ReactNode } from "react";

export interface MyFormProps extends AntdFormProps {
  children?: ReactNode;
}

export interface FormStaticMethods {
  Item: typeof AntdForm.Item;
  create: typeof AntdForm.create;
}

const FormPolyfill: React.FC<MyFormProps> & FormStaticMethods = ({
  children,
  ...props
}) => {
  return <AntdForm {...props}>{children}</AntdForm>;
};

FormPolyfill.Item = AntdForm.Item;
FormPolyfill.create = AntdForm.create;

export default FormPolyfill;
